<app-action-portal-container
	[isSaving]="isSaving"
	(onClosePortal)="onClosePortal()"
	(onClear)="clearTask()"
	(onSubmit)="submitTask()"
	[errorMessages]="errorMessages()"
	[isSaveButtonActive]="true"
	[title]="'vehicles|task|sell-vehicle|title'">
	<app-section-wrapper-container>
		<form class="um-section-parent-container" [formGroup]="taskFormGroup">
			<div>
				<app-datetime-picker
					formControlName="soldAt"
					[label]="'vehicles|task|sell-vehicle|field|sold-at'"
					[excludeFutureDates]="false" />
			</div>
			<div>
				<app-input-field
					formControlName="saleAskPrice"
					[isNumber]="true"
					[label]="'vehicles|task|sell-vehicle|field|sale-ask-price'" />
				<app-input-field
					formControlName="saleSoldPrice"
					[isNumber]="true"
					[label]="'vehicles|task|sell-vehicle|field|sale-sold-price'" />
			</div>

			<app-more-sections label="vehicles|record|purchase-details-section|title">
				<div>
					<app-input-field
						formControlName="purchaseListPrice"
						[isNumber]="true"
						[label]="'vehicles|record|purchase-details-section|field-label|purchase-list-price'" />
					<app-input-field
						formControlName="purchasePaidPrice"
						[isNumber]="true"
						[label]="'vehicles|record|purchase-details-section|field-label|purchase-paid-price'" />
				</div>
				<div>
					<app-datetime-picker
						formControlName="purchasedAt"
						[label]="'vehicles|record|purchase-details-section|field-label|purchased-at'"
						[showTime]="false"
						[excludeFutureDates]="true" />
				</div>
			</app-more-sections>
		</form>
	</app-section-wrapper-container>
</app-action-portal-container>
